import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["width", "height"],
  _excluded2 = ["fit", "width", "height"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { i as l } from "./checks-C6AyTTQ0.js";
const M = /^image-([a-f\d]+)-(\d+x\d+)-(\w+)$/,
  w = {
    auto: "format",
    fit: "max",
    quality: 75
  },
  b = t => !!(t !== null && t !== void 0 && t.asset) && (l(t.asset._id) || l(t.asset._ref)),
  R = function (t) {
    let r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "crop";
    const {
        dimensions: i
      } = f(t.asset._id),
      o = Math.round(i.width / i.height);
    let h = o,
      e = i.width,
      n = i.height;
    if (r != "clip" && "crop" in t && t.crop && Object.values(t.crop).some(s => s && s > 0)) {
      const s = Math.round(i.width - (t.crop.left || 0) * i.width - (t.crop.right || 0) * i.width),
        d = Math.round(i.height - (t.crop.top || 0) * i.height - (t.crop.bottom || 0) * i.height);
      h = Math.round(s / d), h > o ? n = d : e = s;
    }
    return {
      width: e,
      height: n
    };
  },
  f = t => {
    try {
      const [, r, i, o] = M.exec(t) || [],
        [h, e] = i.split("x").map(n => parseInt(n, 10));
      return {
        assetId: r,
        dimensions: {
          width: h,
          height: e
        },
        format: o
      };
    } catch (_unused) {
      throw new Error("Could not parse image ID \"".concat(t, "\""));
    }
  },
  I = t => {
    const {
      asset: r,
      hotspot: i,
      crop: o
    } = t;
    return r ? _objectSpread(_objectSpread({}, r), {}, {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      _id: r._id || r._ref,
      hotspot: i,
      crop: o
    }) : void 0;
  },
  S = t => {
    if (t) return typeof t != "string" && "localized" in t ? t.localized : t;
  },
  A = (t, r, _ref) => {
    let {
        width: i,
        height: o
      } = _ref,
      h = _objectWithoutProperties(_ref, _excluded);
    const {
        dimensions: e
      } = f(r._id),
      n = e.width / e.height;
    return i = i || e.width, o = o || Math.round(i / n), x(t, r, _objectSpread(_objectSpread({}, h), {}, {
      width: i,
      height: o
    }));
  },
  j = (t, r, i) => {
    const {
        dimensions: o
      } = f(r._id),
      h = i.fit || w.fit,
      e = o.width / o.height,
      n = i.width || o.width,
      s = i.height || Math.round(n / e),
      d = n / s;
    let u = e,
      p = o.width,
      g = o.height;
    if (h != "clip" && "crop" in r && r.crop && Object.values(r.crop).some(c => c && c > 0)) {
      const c = o.width - (r.crop.left || 0) * o.width - (r.crop.right || 0) * o.width,
        a = o.height - (r.crop.top || 0) * o.height - (r.crop.bottom || 0) * o.height;
      u = c / a, u > e ? g = a : p = c;
    }
    return Object.values([0.5, 1, 1.5, 2, 3].reduce((c, a) => {
      const _ = x(t, r, _objectSpread(_objectSpread({}, i), {}, {
          dpr: a
        })),
        m = Math.round(
        // For modes where Sanity will not scale up, determine
        // the anticipated final width based on the params
        ["fillmax", "max", "min"].includes(h) ? d < e ? Math.min(g / (s * a) * (n * a), n * a) : Math.min(n * a, p) : n * a);
      return c[m] || (c[m] = "".concat(_, " ").concat(m, "w")), c;
    }, {})).join(", ");
  },
  x = function (t, r) {
    let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const {
        fit: o,
        width: h,
        height: e
      } = i,
      n = _objectWithoutProperties(i, _excluded2);
    let s = {
      fit: o,
      width: h,
      height: void 0
    };
    return o != "clip" && (s = _objectSpread(_objectSpread({}, s), {}, {
      height: e
    })), o == "clip" && (s = _objectSpread(_objectSpread({}, s), {}, {
      fit: "max"
    })), Object.entries(_objectSpread(_objectSpread(_objectSpread({}, w), s), n)).reduce((d, _ref2) => {
      let [u, p] = _ref2;
      return p ? Array.isArray(p) ? d[u](...p) : d[u](p) : d;
    }, t.image(r)).url().replace(/, /g, ",");
  };
export { x as a, A as b, R as c, j as d, S as g, b as i, f as p, I as t };